import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import HotelFacilityList from './HotelFacilityList';
import HotelFacilityUpdate from './HotelFacilityUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsFacilityHotelStore'
)
@observer
class HotelFacilityPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsFacilityHotelStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsFacilityHotelStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsFacilityHotelStore.setshowModal(false);
    }

    render() {
        const {
            showModal,
            modalTitle
        } = this.props.CmsFacilityHotelStore;

        return (
            <MainContainer title='Hotel Facility Management' menukey='facilities'>
                <Modal
                    title={modalTitle}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <HotelFacilityUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <HotelFacilityList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default HotelFacilityPage